import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.less']
})
export class ContractComponent implements OnInit {

  @Input() code = 0;
  @Input() pno: any;
  @Input() cid: any;
  providers = [];
  directors = [];
  validateForm: FormGroup;
  uploadFileList: any[] = [];
  filePathList: any[] = [];
  fileType = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'img'];
  constructor(
    private providerService: ProviderService,
    private fb: FormBuilder,
  ) { }

  async ngOnInit(): Promise<void> {
    this.validateForm = this.fb.group({
      contractName: [null, [Validators.required]], // 合同名称
      contractNo: [null, [Validators.required]], // 合同编号
      contractMoney: [null, [Validators.required]], // 合同金额
      payDirect: ['1'], // 付款方向 //默认为付款
      payMethod: ['1'], // 付款方式 默认为转账
      status: ['0'], // 付款方式 默认为转账
      signContractDate: [null], // 合同签订日期
      providerLeader: [null], // 供应商负责人
      projectLeader: [null], // 项目负责人
      startContractDate: [null], // 合同开始日期
      endContractDate: [null], // 合同结束日期
      contractContent: [null], // 合同内容
      pno: [this.pno, [Validators.required]], // 供应商编号
      mark: [null], // 备注
      responseTimeEvaluation: this.code === 2 ? [null, [Validators.required]] : [null], // 合同名称
      serviceEfficiencyQualityEvaluation: this.code === 2 ? [null, [Validators.required]] : [null], // 合同编号
      servicePrice: this.code === 2 ? [null, [Validators.required]] : [null], //
      otherEvaluation: this.code === 2 ? [null, [Validators.required]] : [null], //
    });
    if (this.code === 1 || this.code === 2){
      this.providerService.getContract(this.cid).subscribe((data: any) => {
        if ( !this.isEmpty(data) ){
          this.setValidateForm(data);
          const fList = [];
          if (!this.isEmpty(data.filePaths)){
            data.filePaths.forEach(element => {
              let fileNode = new FileNode();
              fileNode = {
                uid: element.id,
                name: element.name,
                url: element.url,
                status: 'done',
                showDownload: false,
                type: element.type,
                response: { code: 200, data: { url: element.url } },
                iconType: '',
                isImageUrl: false,
                isUploading: false,
                linkProps: undefined,
                message: ''
              };
              fList.push(fileNode);
            });
          }
          this.uploadFileList = fList;
          if (this.code === 2){
            this.validateForm.disable();
          }
        }
      });
    }
    this.providers = await this.providerService.getProviderList();
    await this.providerService.getDirectors().then((data) => {
      this.directors = data;
    });
  }
  getContractForm(){
    return this.validateForm;
  }
  getFilePathList(){
    this.filePathList = [];
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.forEach(element => {
        if (element.response.code === 200) {
          if (this.fileType.some(e => e === element.type)) {
            element.type = 'img';
          } else {
            element.type = 'txt';
          }
          const node = {
            name: element.name,
            url: element.response.data.url,
            type: element.type
          };
          this.filePathList.push(node);
        }
      });
    } else {
      this.filePathList = [];
    }
    return this.filePathList;
  }
  async  handleChange({ file, fileList }: NzUploadChangeParam) {
    if (file.status === 'uploading') {
      return;
    }
    let fList = fileList;
    fList = fList.map(fe => {
      if (fe.response.code === 200) {
        // Component will show file.url as link
        fe.url = 'attachmentServer' + fe.response.data.url;
      }
      return fe;
    });
    this.uploadFileList = fList;
    console.log(this.uploadFileList);
  }

  removeFile = (file: NzUploadFile) => {
    if (this.code === 2) {
      return false;
    } else {
      return true;
    }
  }
  setValidateForm(contract: any){
    this.validateForm.get('contractName').setValue(!this.isEmpty(contract.contractName) ? contract.contractName : null);
    this.validateForm.get('contractNo').setValue(!this.isEmpty(contract.contractNo) ? contract.contractNo : null);
    this.validateForm.get('contractMoney').setValue(!this.isEmpty(contract.contractMoney) ? contract.contractMoney : null);
    this.validateForm.get('signContractDate').setValue(!this.isEmpty(contract.signContractDate) ? contract.signContractDate : null);
    this.validateForm.get('startContractDate').setValue(!this.isEmpty(contract.startContractDate) ? contract.startContractDate : null);
    this.validateForm.get('endContractDate').setValue(!this.isEmpty(contract.endContractDate) ? contract.endContractDate : null);
    this.validateForm.get('payDirect').setValue(!this.isEmpty(contract.payDirect) ? contract.payDirect : null);
    this.validateForm.get('payMethod').setValue(!this.isEmpty(contract.payMethod) ? contract.payMethod : null);
    this.validateForm.get('status').setValue(!this.isEmpty(contract.status) ? contract.status : null);
    this.validateForm.get('providerLeader').setValue(!this.isEmpty(contract.providerLeader) ? contract.providerLeader : null);
    this.validateForm.get('projectLeader').setValue(!this.isEmpty(contract.projectLeader) ? Number(contract.projectLeader) : null);
    this.validateForm.get('pno').setValue(!this.isEmpty(contract.pno) ? contract.pno : null);
    this.validateForm.get('contractContent').setValue(!this.isEmpty(contract.contractContent) ? contract.contractContent : null);
    this.validateForm.get('mark').setValue(!this.isEmpty(contract.mark) ? contract.mark : null);
    // 供应商评价
    this.validateForm.get('responseTimeEvaluation').setValue(
      !this.isEmpty(contract.responseTimeEvaluation) ? contract.responseTimeEvaluation : null);
    this.validateForm.get('serviceEfficiencyQualityEvaluation').setValue(
      !this.isEmpty(contract.serviceEfficiencyQualityEvaluation) ? contract.serviceEfficiencyQualityEvaluation : null);
    this.validateForm.get('servicePrice').setValue(
      !this.isEmpty(contract.servicePrice) ? contract.servicePrice : null);
    this.validateForm.get('otherEvaluation').setValue(
      !this.isEmpty(contract.otherEvaluation) ? contract.otherEvaluation : null);
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
class FileNode implements NzUploadFile {
  uid: string;
  name: string;
  [key: string]: any;
}
